import PATH from '@/routes/path';
import { ROLE, STAGE_GRADUATION_STATUS } from '@/shared/constants/user';
import { UserInfoType } from '@/types/auth';

/**
 * Where a user lands when they enter the app — used both right after login and
 * when opening the root path, so the two cannot drift apart.
 */
export function getRedirectPathByUser(userInfo: UserInfoType): string {
  const role = userInfo?.current_roles?.[0];
  const isTrial =
    userInfo?.stage_graduation_status === STAGE_GRADUATION_STATUS.TRIAL;

  if ([ROLE.SUPPER_ADMIN, ROLE.ADMIN].includes(role)) {
    return PATH.coach_management;
  }
  if (role === ROLE.MENTOR) return PATH.mentor_coach_management;
  if (role === ROLE.TEACHER && isTrial) return PATH.profile;

  return PATH.student_management;
}
